import { render } from "./TrackerCreateThirdStep.vue?vue&type=template&id=ba3c5116"
import script from "./TrackerCreateThirdStep.vue?vue&type=script&lang=js"
export * from "./TrackerCreateThirdStep.vue?vue&type=script&lang=js"
script.render = render

export default script